import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {BaseNamedRouterLinkDirective} from '@aviary/directives/base-named-router-link.directive';
import {NgTemplateOutlet} from '@angular/common';
import {ROUTE_NAME_CAPABLE_BUTTON_COMPONENT} from '@aviary/injection-tokens/aviary-only.tokens';
import {MatTooltip} from '@angular/material/tooltip';
import {RectangularButtonComponent} from '@aviary/buttons/base/rectangular-button/rectangular-button.component';
import {RectangularButtonContentComponent} from '@aviary/buttons/base/rectangular-button-content/rectangular-button-content.component';

@Component({
  selector: 'mx-text-button',
  templateUrl: './text-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {provide: ROUTE_NAME_CAPABLE_BUTTON_COMPONENT, useExisting: TextButtonComponent}
  ],
  imports: [MatButton, BaseNamedRouterLinkDirective, NgTemplateOutlet, MatTooltip, RectangularButtonContentComponent]
})
export class TextButtonComponent extends RectangularButtonComponent {
  // See BaseButtonComponent and RectangularButtonComponent for the rest of the available inputs.
  @Input() public color: string = this.config.defaultColors.text;
}
